import { Field } from './Field/Field';

type Props = {
  name: string;
};

export function HiddenField({ name }: Props) {
  return (
    <Field
      name={name}
      renderInput={({ value, id, qaId }) => (
        <input
          id={id}
          name={name}
          value={value ?? ''}
          data-qa-id={qaId}
          hidden
          readOnly
        />
      )}
      hidden
    />
  );
}
